import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICON_ERROR } from '../../named-icons.config';

@Component({
  selector: 'app-input-error-icon',
  templateUrl: 'input-error-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputErrorIconComponent {
  public readonly ICON_ERROR = ICON_ERROR;
}
